module.exports = __webpack_public_path__ + "img/鹤壁市.185820a1.png";